import controller from './thing-star.controller';

const template = require('./thing-star.html');

export default {
    bindings: {
        starred: '<',
        thingId: '<',
        onToggleStatus: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/common/thing-star/thing-star.component.js